import { useState } from "react";
import { Col, Form, Nav, Row } from "react-bootstrap";
import { StyledNav } from "../OnlineStoreData/styles";
import InterestRateData from "./InterestRateData";
import { AuthValues, useAuth } from "../../../contexts/authContext";
import userHasRoles from "../../../utils/userHasRoles";
import Role from "../../../constants/roles";
import PaymentMethodsData from "./PaymentMethods";
import SpecialFinancingData from "./SpecialFinancing";



function FinancingData() {
    const [tab, setTab] = useState('special-financing');
    const { user }: AuthValues = useAuth();
    const isAdministrator = userHasRoles(user, [Role.Administrator]);

    return (
        <>
            <Form.Group controlId="formConfiguration">
                <Row className="mb-3">
                    <Col md={8}>
                        <StyledNav
                            variant="tabs"
                            activeKey={tab}
                            onSelect={(selectedKey: string) =>
                                setTab(selectedKey)
                            }
                        >
                            {isAdministrator && (
                                <Nav.Item>
                                    <Nav.Link eventKey="special-financing">
                                        Financiamento Especial
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            {isAdministrator && (
                                <Nav.Item>
                                    <Nav.Link eventKey="interest-rates">
                                        Taxas de Juros
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                            {isAdministrator && (
                                <Nav.Item>
                                    <Nav.Link eventKey="payment-methods">
                                        Meios de pagamento
                                    </Nav.Link>
                                </Nav.Item>
                            )}
                        </StyledNav>
                    </Col>
                </Row>

                    {tab === 'special-financing' && (<SpecialFinancingData />)}
                    {tab === 'interest-rates' && <InterestRateData />}
                    {tab === 'payment-methods' && <PaymentMethodsData />}
            </Form.Group>
        </>
    );
}

export default FinancingData;